/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { defineResource } from 'pulse/resources';
import { fromRPC } from 'pulse/adapters';
import * as References from './PortalDataRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

// RPC Resources

export const GetPortalDataRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.PortalDataRpc.getPortalData',
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getPortalDataRpc,
    rpcClient: chirpClient
  })
}).register();